import * as actions from '../actions/';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import HomePage from '../components/homepage/homepage';

const mapStateToProps = (state) => {
  return {
    entity: state.store.entity,
    defaultOptions: state.store.defaultOptions,
    featuredListings: state.store.featuredListings,
    heroListings: state.store.heroListings,
    ourAdvantageSlides: state.store.ourAdvantageSlides,
    press: state.store.press,
    testimonials: state.store.testimonials
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);



// WEBPACK FOOTER //
// ./src/containers/homepage.js